const Ajax = require('jiji/infra/ajax');

class API {
    getUser() {
        return Ajax.GET('/api/user');
    }

    getAccounts() {
        return Ajax.GET('/api/user/accounts');
    }

    connect(json) {
        return Ajax.POST('/api/user/connect', json);
    }

    signup(json) {
        return Ajax.POST('/api/user/signup', json);
    }

    getUnconnectedAccounts() {
        return Ajax.GET('/api/user/accounts/unconnected');
    }

    idlogin(json) {
        return Ajax.POST('/api/user/session', json);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./jiji/infra/api/user.js